module.controller(
    'regulationAnalysisDetailCtrl',
    [ '$scope', '$rootScope', '$state', 'regulationService', 'sampleElementService','alertService','analysisService', 'ASEBIOL_CONSTANTS',
        function($scope, $rootScope, $state, regulationService,sampleElementService, alertService,analysisService,ASEBIOL_CONSTANTS) {
            
    		$scope.validation = {name: {maxlength:255},
    				sigla: {maxlength:5}
    		};
    		
    		$scope.operationType = $state.current.data.type;
            $scope.idRegulation = $state.params.idRegulation;
            $scope.idAnalysis = $state.params.idAnalysis;
            $scope.techniques = [];
            $scope.varShowHide = false;
            $scope.filter = {};
            $scope.analysis = {
            		type:[],
            		sampleUnits:{},
            		sampleElements:{},
            		sampleElementsParticular:[],
            		sampleElementsGeneral:[]
            };
            $scope.loading = false;
            $scope.contact = {};
            
            $scope.technique = {
        			MinAmountUnits : {},
        			ResultTypeUnits : {},
        			resulttype : null,
        			presenceAbsenceLimit : false,
        			dilutions: {}
        		};
            $scope.pagination = {
                    current : 1,
                    total : 0
                };
        	
        	$scope.techniqueSelected=[];
        	$scope.methodSelected=[];
        	$scope.techSelect;
        	
          	$scope.CNT = ASEBIOL_CONSTANTS;
            
            /**
             * 
             */
            $scope.load = function(idRegulation, idAnalysis) {
                $scope.loading = true;

                regulationService.getRegulationAnalysis(idRegulation, idAnalysis).then(function(response) {
                    $scope.loading = false;

                    var responseData = response.getData();
                    $scope.analysis = {
                    		name: responseData.name,                    		                    		
                    		active: responseData.active,
                    		totalTechniques: responseData.totalTechniques,
		                    sampleElements : responseData.sampleElements,
		                    sampleElementsParticular:[],
		                    sampleElementsGeneral:[],
		                    numTubes: responseData.numTubes,
		                    type:[],
		            		sigla : responseData.sigla
		                };

                    $scope.analysis.type.selected = [responseData.type];
                    
                    $scope.analysis.sampleElementsParticular.selected = $scope.analysis.sampleElements.filter(function(item){ return item.sampleElementType == 'PARTICULARES'});
                    $scope.analysis.sampleElementsGeneral.selected = $scope.analysis.sampleElements.filter(function(item){ return item.sampleElementType == 'GENERALES'});
                    
                }, function(response) {
                    $scope.loading = false;
                });
            };
            
            $scope.search = function(page) {
                $scope.loading = true;
                
                page = page == undefined ? 1 : page;
                $scope.pagination.current = page;

                var filter = {};
                filter.offset = (page - 1) * $rootScope.pageSize;
                filter.limit = $rootScope.pageSize;
                filter.visible = $scope.filter.visible;
                filter.Analysis = $scope.idAnalysis;

                if($scope.filter.name){
                    filter.name = $scope.filter.name;
                }
                
                analysisService.searchAnalysisTechnique(filter).then(function(response) {
                    $scope.loading = false;
                    var result = response.getData();
                    $scope.techniques = result;
                    $scope.pagination.total = result.length;
                }, function(response) {
                    $scope.loading = false;
                });
            };
            
            $scope.loadGeneral = function() {
                $scope.loading = true;
                
                var filter = {sampleElementType: 'GENERALES', name: ''};
                sampleElementService.searchSamplesElements(filter).then(function(response) {
                	$scope.loading = false;
					$scope.analysis.sampleElementsGeneral.selected = response.getData().results;
                }, function(response) {
                	//on error
                	$scope.loading = false;
                });
            };

            /**
             *
             */
            $scope.sendAction = function() {
                if ($scope.operationType == 'create') {
                    $scope.create();
                } else {
                    $scope.update();
                }
            };

            /**
             *
             */
            $scope.create = function() {
                alertService.showSwtQuestion('Crear Análisis', function() {
                    $scope.loading = true;

                    var createModel = {
                    	name: $scope.analysis.name,
                    	idSampleElements:[],
                    	idType: $scope.analysis.type.selected[0].id,
                    	sigla: $scope.analysis.sigla
                    };
                    
                    var items = $scope.analysis.sampleElementsGeneral.selected;
                    if(items){
                    	createModel.idSampleElements = createModel.idSampleElements.concat(items.map(function(item){return item.id}));
                    }
                    var items = $scope.analysis.sampleElementsParticular.selected;
                    if(items){
                    	createModel.idSampleElements = createModel.idSampleElements.concat(items.map(function(item){return item.id}));
                    }                    
                    
                    analysisService.createAnalysis(createModel).then(function(response) {
                    	console.log(createModel);
                        $scope.loading = false;
                        alertService.showSuccess('Análisis creado satisfactoriamente');
                        $state.go('home.AnalysisList');
                    }, function(response) {
                        $scope.loading = false;
                    });
                });
            };

            /**
             *
             */
            $scope.update = function() {
                alertService.showSwtQuestion('Actualizar análisis', function() {
                    $scope.loading = true;

                    var updateModel = {
                        	name: $scope.analysis.name,
                        	idSampleElements:[],
		                    idType: $scope.analysis.type.selected[0].id,
		                	sigla: $scope.analysis.sigla
                        };

                    var items = $scope.analysis.sampleElementsGeneral.selected;
                    if(items){
                    	updateModel.idSampleElements = updateModel.idSampleElements.concat(items.map(function(item){return item.id}));
                    }
                    var items = $scope.analysis.sampleElementsParticular.selected;
                    if(items){
                    	updateModel.idSampleElements = updateModel.idSampleElements.concat(items.map(function(item){return item.id}));
                    } 
                    
                    regulationService.updateRegulationAnalysis($scope.idRegulation, $scope.idAnalysis, updateModel).then(function(response) {
                        $scope.loading = false;
                        alertService.showSuccess('Análisis actualizado satisfactoriamente');
                        $state.go('home.AnalysisList');
                    }, function(response) {
                        $scope.loading = false;
                    });
                });
            };

            if ($scope.operationType == 'update') {
                $scope.load($scope.idRegulation, $scope.idAnalysis);
            }
            if ($scope.operationType == 'create') {
                $scope.loadGeneral();
            }
            
            
            $scope.getNameType = function(m){
            	var txtInfo = '';
            	if(m.resulttype == 'PRESENT_LACK'){}
            	else if(m.resulttype == 'RANGE'){
            		txtInfo = m.lowerRange + '-' + m.lowerRange;
            	}
            	if(txtInfo == ''){
            		return getConstantNameById(eval('TECHNIQUE_TYPE'), m.resulttype);
            	}
            	return getConstantNameById(eval('TECHNIQUE_TYPE'), m.resulttype)+' (' + txtInfo+")";
            };
            
            $scope.ShowHide = function(){
                $scope.varShowHide =! $scope.varShowHide;
            }
            
        	$scope.addTechniqueInAnalisis = function() {
        		alertService.showSwtQuestion('Añadir Técnica', function() {
        			$scope.loading = true;
        			
        			
        			var tech = $scope.techniqueSelected.selected[0];
        			var method = $scope.methodSelected.selected[0];
        	
        			var createModel = {
        				method: method.id,
        				precision : $scope.technique.precision
        				
        			};
        			regulationService.addTechniqueInAnalysis($scope.idRegulation, $scope.idAnalysis, tech.id ,createModel).then(function(response) {
        				$scope.loading = false;
        				alertService.showSuccess('Técnica añadida satisfactoriamente');
        				 $scope.search(1);
        				
        			}, function(response) {
        				$scope.loading = false;
        			});
        		});
        	};
        	
        	$scope.checkUncertainty = function(data) {
        		var regVal = $scope.CNT.REGEX_3DECIMAl.test(data);
        		if (!regVal) {
        			return "Debe ser un número positivo \r\n y máximo 3 decimales";
        		}
        	};
        	
            $scope.clearFilters = function(){
            	$scope.filter = {};
            };
            
            $scope.removeTechniqueAnalysis = function(idAnalysis,idtechnique,idMethod) {
            	
            	alertService.showSwtQuestion('Elminar Técnica del Analisis', function() {
            		analysisService.removeTechniqueAnalysis(idAnalysis,idtechnique,idMethod).then(function(response) {
        				$scope.loading = false;
        				alertService.showSuccess('Técnica eliminada satisfactoriamente');
        				 $scope.search(1);
        				
        			}, function(response) {
        				$scope.loading = false;
        			});
        		});
				
			}
        	
        	 $scope.search(1);

        } ]);


